
@switch (currentStep()) {
  @case (1) {
    <app-create-1 (stepChange)="onStepChange($event)"></app-create-1>
  }
  @case (2) {
    <app-create-2 (stepChange)="onStepChange($event)"></app-create-2>
  }
  @case (3) {
    <app-create-3 (stepChange)="onStepChange($event)"></app-create-3>
  }
}